export const REGISTER_FORM_IDENTIFIER = 'register'; // @NOTE-RT: This should really be 'app/RegisterPage/RegisterForm', but don't chance it right now...

export const SAVE = 'app/RegisterPage/SAVE';
export const SAVE_SUCCESS = 'app/RegisterPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/RegisterPage/SAVE_FAILED';

export const RESET_DIALOG = 'app/RegisterPage/RESET_DIALOG';
